import { Loader2 } from "lucide-react";

export function SubscriptionLoading() {
  return (
    <div className="container mx-auto py-8 flex justify-center">
      <Loader2 className="h-8 w-8 animate-spin" />
    </div>
  );
}